import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'events-untrackedproducttile-view';
/**
 * Tracking event used to track all product tiles, which are not setup to fire impression events ATM.
 */
export function trackEventsUntrackedproducttileView(retailerToken, productToken, pathname) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { retailerToken, productToken, pathname },
    });
}
